import { render, staticRenderFns } from "./orderSettlement.vue?vue&type=template&id=7f4cc9c8"
import script from "./orderSettlement.vue?vue&type=script&lang=js"
export * from "./orderSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports